import React from "react"
import "../../src/index.css"

import {
  Rotation3D,
  SixFtApart,
  Rotate360,
  Accessibility,
  AccessibilityNew,
  Accessible,
  AccessibleForward,
  AccountBalance,
  AccountBalanceWallet,
  AccountBox,
  AccountCircle,
  AddAlert,
  AddBusiness,
  AddChart,
  AddExpense,
  AddExpenseTwo,
  AddIcCall,
  AddLocation,
  AddLocationAlt,
  AddModerator,
  AddRoad,
  AddShoppingCart,
  AddTask,
  AddToDrive,
  AdminPanelSettings,
  Agriculture,
  Alarm,
  AlarmAdd,
  AlarmOff,
  AlarmOn,
  AllInbox,
  AllOut,
  AlternateEmail,
  AltRoute,
  Analytics,
  Anchor,
  Android,
  Announcement,
  Api,
  AppBlocking,
  AppRegistration,
  Approval,
  Apps,
  AppSettingsAlt,
  Architecture,
  ArrowBack,
  ArrowBackIos,
  ArrowCircleDown,
  ArrowCircleUp,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropDownCircle,
  ArrowDropUp,
  ArrowForward,
  ArrowForwardIos,
  ArrowForwardIosAlt,
  ArrowLeft,
  ArrowRight,
  ArrowRightAlt,
  ArrowUpward,
  Article,
  AspectRatio,
  Assessment,
  Assignment,
  AssignmentInd,
  AssignmentLate,
  AssignmentReturn,
  AssignmentReturned,
  AssignmentTurnedIn,
  AssistantDirection,
  AssistantNavigation,
  Atm,
  AttachEmail,
  Attachment,
  Attractions,
  AutoDelete,
  AutoRenew,
  Backup,
  BackupTable,
  Badge,
  BakeryDining,
  BatchPrediction,
  BeenHere,
  BikeScooter,
  Book,
  Bookmark,
  BookmarkBorder,
  Bookmarks,
  BookOnline,
  BreakfastDining,
  BrunchDining,
  BugReport,
  Build,
  BuildCircle,
  BusAlert,
  Business,
  Cached,
  Cake,
  CalendarToday,
  CalendarViewDay,
  Call,
  CallEnd,
  CallMade,
  CallMerge,
  CallMissed,
  CallMissedOutgoing,
  CallReceived,
  CallSplit,
  CameraEnhance,
  Campaign,
  Cancel,
  CancelPresentation,
  CancelScheduleSend,
  CardGiftcard,
  CardMembership,
  CardTravel,
  CarRental,
  CarRepair,
  Category,
  Celebration,
  CellWifi,
  ChangeHistory,
  Chat,
  ChatBubble,
  ChatBubbleOutline,
  Check,
  CheckCircle,
  CheckCircleOutline,
  ChevronLeft,
  ChevronRight,
  ChromeReaderMode,
  CircleNotifications,
  Class,
  CleanHands,
  CleaningServices,
  ClearAll,
  Clock,
  Close,
  CloseFullscreen,
  Cloud,
  CloudCircle,
  CloudDone,
  CloudDownload,
  CloudOff,
  CloudQueue,
  CloudUpload,
  Code,
  Comment,
  CommentBank,
  Commute,
  CompareArrows,
  CompassCalibration,
  Compress,
  ConnectWithoutContact,
  Construction,
  Contactless,
  ContactMail,
  ContactPage,
  ContactPhone,
  Contacts,
  ContactSupport,
  Copyright,
  Coronavirus,
  CreateNewFolder,
  CreditCard,
  Cut,
  Dangerous,
  Dashboard,
  DashboardCustomize,
  DateRange,
  Deck,
  Delete,
  DeleteForever,
  DeleteOutline,
  DeliveryDining,
  DepartureBoard,
  Description,
  DesignServices,
  DesktopAccessDisabled,
  DialerSip,
  Dialpad,
  DinnerDining,
  Directions,
  DirectionsBike,
  DirectionsBoat,
  DirectionsBus,
  DirectionsCar,
  DirectionsRailway,
  DirectionsRun,
  DirectionsSubway,
  DirectionsTransit,
  DirectionsWalk,
  DisabledByDefault,
  Dns,
  Domain,
  DomainDisabled,
  DomainVerification,
  Done,
  DoneAll,
  DoneOutline,
  DonutLarge,
  DonutSmall,
  DoubleArrow,
  DragIndicator,
  DriveFileMove,
  DriveFileMoveOutline,
  DriveFileRenameOutline,
  DriveFolderUpload,
  DryCleaning,
  DSOTruck,
  Duo,
  DynamicForm,
  East,
  Eco,
  Edit,
  EditAttributes,
  EditLocation,
  EditOff,
  EditRoad,
  Eject,
  Elderly,
  ElectricalServices,
  ElectricBike,
  ElectricCar,
  ElectricMoped,
  ElectricRickshaw,
  ElectricScooter,
  Email,
  EmojiEmotions,
  EmojiEvents,
  EmojiFlags,
  EmojiFoodBeverage,
  EmojiNature,
  EmojiObjects,
  EmojiPeople,
  EmojiSymbols,
  EmojiTransportation,
  Engineering,
  Error,
  ErrorOutline,
  EuroSymbol,
  Event,
  EventSeat,
  EvStation,
  ExitToApp,
  Expand,
  ExpandLess,
  ExpandMore,
  Explore,
  ExploreOff,
  Extension,
  Face,
  Facebook,
  FactCheck,
  Fastfood,
  Favorite,
  FavoriteBorder,
  Feedback,
  Festival,
  File,
  FileDownload,
  FileDownloadDone,
  FilePresent,
  FileUpload,
  FilterAlt,
  FilterListAlt,
  FindInPage,
  FindReplace,
  Fingerprint,
  Fireplace,
  FirstPageAlt,
  FirstPage,
  FitScreen,
  Flaky,
  Flight,
  FlightLand,
  FlightTakeoff,
  FlipToBack,
  FlipToFront,
  Folder,
  FolderOpen,
  FolderShared,
  FollowTheSigns,
  Forum,
  ForwardToInbox,
  Fullscreen,
  FullscreenExit,
  Gavel,
  GetApp,
  Gif,
  Grade,
  Grading,
  GridView,
  Group,
  GroupAdd,
  Groups,
  GroupWork,
  GTranslate,
  Hail,
  Handyman,
  Hardware,
  Help,
  HelpCenter,
  HelpOutline,
  HighlightAlt,
  HighlightOff,
  History,
  HistoryEdu,
  HistoryToggleOff,
  Home,
  HomeFilled,
  HomeRepairService,
  HomeWork,
  HorizontalSplit,
  Hotel,
  HourglassBottom,
  HourglassDisabled,
  HourglassEmpty,
  HourglassFull,
  HourglassTop,
  Http,
  Https,
  Hvac,
  Icecream,
  IconSwerage,
  IconSwerageAlt,
  ImportantDevices,
  ImportContacts,
  ImportExport,
  Info,
  InfoOutline,
  Input,
  IntegrationInstructions,
  InvertColors,
  InvertColorsOff,
  IosShare,
  KingBed,
  Label,
  LabelImportant,
  LabelImportantOutline,
  LabelOff,
  LabelOutline,
  TranslateLanguage,
  Language,
  LastPageAlt,
  LastPage,
  Launch,
  Layers,
  LayersClear,
  Leaderboard,
  LegendToggle,
  Lightbulb,
  LightbulbOutline,
  LineStyle,
  LineWeight,
  Liquor,
  List,
  ListAlt,
  LiveHelp,
  LocalActivity,
  LocalAirport,
  LocalAtm,
  LocalBar,
  LocalCafe,
  LocalCarWash,
  LocalConvenienceStore,
  LocalDining,
  LocalDrink,
  LocalFireDepartment,
  LocalFlorist,
  LocalGasStation,
  LocalGroceryStore,
  LocalHospital,
  LocalHotel,
  LocalLaundryService,
  LocalLibrary,
  LocalMall,
  LocalMovies,
  LocalOffer,
  LocalParking,
  LocalPharmacy,
  LocalPhone,
  LocalPizza,
  LocalPlay,
  LocalPolice,
  LocalPostOffice,
  LocalPrintshop,
  LocalSee,
  LocalShipping,
  LocalTaxi,
  LocationCity,
  LocationOff,
  LocationOn,
  LocationPin,
  Lock,
  LockClock,
  LockOpen,
  LockOutline,
  Login,
  Logout,
  Loyalty,
  Luggage,
  LunchDining,
  MailOutline,
  Map,
  MapsUgc,
  MarkAsUnread,
  MarkChatRead,
  MarkChatUnread,
  MarkEmailRead,
  MarkEmailUnread,
  MarkunreadMailbox,
  Masks,
  Maximize,
  Mediation,
  MedicalServices,
  Menu,
  MenuBook,
  MenuOpen,
  Message,
  MilitaryTech,
  Minimize,
  MiscellaneousServices,
  MobileScreenShare,
  ModelTraining,
  Money,
  Mood,
  MoodBad,
  Moped,
  MoreHoriz,
  MoreTime,
  MoreVert,
  MultipleStop,
  Museum,
  MyLocation,
  Nat,
  Navigation,
  NearMe,
  NearMeDisabled,
  NextPlan,
  Nightlife,
  NightlightRound,
  NightsStay,
  NoLuggage,
  NoMeals,
  NoMealsOuline,
  North,
  NorthEast,
  NorthWest,
  NoSim,
  NotAccessible,
  NoteAdd,
  NotificationImportant,
  Notifications,
  NotificationsActive,
  NotificationsNone,
  NotificationsOff,
  NotificationsPaused,
  NotListedLocation,
  NoTransfer,
  NotStarted,
  TorchNoun,
  OfflineBolt,
  OfflinePin,
  OfflineShare,
  OnlinePrediction,
  Opacity,
  OpenInBrowser,
  OpenInFull,
  OpenInNew,
  OpenWith,
  Outbond,
  Outbox,
  OutdoorGrill,
  OutgoingMail,
  Outlet,
  Pages,
  Pageview,
  PanTool,
  Park,
  PartyMode,
  PausePresentation,
  Payment,
  Payments,
  PedalBike,
  Pending,
  PendingActions,
  People,
  PeopleAlt,
  PeopleOutline,
  PermCameraMic,
  PermContactCalendar,
  PermDataSetting,
  PermDeviceInformation,
  PermIdentity,
  PermMedia,
  PermPhoneMsg,
  PermScanWifi,
  Person,
  PersonAdd,
  PersonAddAlt,
  PersonAddSecondary,
  PersonAddDisabled,
  PersonOutline,
  PersonPin,
  PersonPinCircle,
  PersonRemove,
  PersonRemoveAlt,
  PersonSearch,
  PestControl,
  PestControlRodent,
  Pets,
  Phone,
  PhoneDisabled,
  PhoneEnabled,
  PhonelinkErase,
  PhonelinkLock,
  PhonelinkRing,
  PhonelinkSetup,
  PictureInPicture,
  PictureInPictureAlt,
  PinDrop,
  PivotTableChart,
  Place,
  Plagiarism,
  PlayForWork,
  Plumbing,
  PlusOne,
  Poll,
  Polymer,
  Population,
  PortableWifiOff,
  PowerSettingsNew,
  PregnantWoman,
  PresentToAll,
  Preview,
  Print,
  PrintDisabled,
  PrivacyTip,
  Psychology,
  Public,
  PublicOff,
  PublishedWithChanges,
  QrCode,
  QrCodeScanner,
  QueryBuilder,
  QuestionAnswer,
  Quickreply,
  RailwayAlert,
  RamenDining,
  RateReview,
  ReadMore,
  Receipt,
  Recommend,
  RecordVoiceOver,
  Redeem,
  ReduceCapacity,
  Refresh,
  RemoveDone,
  RemoveModerator,
  RemoveShoppingCart,
  Reorder,
  ReportProblem,
  RequestPage,
  RequestQuote,
  Restaurant,
  RestaurantMenu,
  Restore,
  RestoreFromTrash,
  RestorePage,
  RingVolume,
  Room,
  RoundedCorner,
  Rowing,
  RssFeed,
  Rtt,
  Rule,
  RuleFolder,
  RunCircle,
  Sanitizer,
  Satellite,
  SavedSearch,
  Schedule,
  ScheduleSend,
  School,
  Science,
  ScreenShare,
  Search,
  SearchOff,
  Segment,
  SelfImprovement,
  SendAndArchive,
  SentimentDissatisfied,
  SentimentNeutral,
  SentimentSatisfied,
  SentimentSatisfiedAlt,
  SentimentVeryDissatisfied,
  SentimentVerySatisfied,
  SetMeal,
  Settings,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputVideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsPower,
  SettingsRemote,
  SettingsVoice,
  Share,
  Shop,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  ShopAlt,
  Sick,
  SingleBed,
  SmartButton,
  SnippetFolder,
  Source,
  South,
  SouthEast,
  SouthWest,
  SpeakerNotes,
  SpeakerNotesOff,
  SpeakerPhone,
  SpellCheck,
  Sports,
  SportsBaseball,
  SportsBasketball,
  SportsCricket,
  SportsEsports,
  SportsFootball,
  SportsGolf,
  SportsHandball,
  SportsHockey,
  SportsKabaddi,
  SportsMma,
  SportsMotorsports,
  SportsRugby,
  SportsSoccer,
  SportsTennis,
  SportsVolleyball,
  StarRate,
  Stars,
  StayCurrentLandscape,
  StayCurrentPortrait,
  StayPrimaryLandscape,
  StayPrimaryPortrait,
  StickyNotesSecondary,
  ScreenShareStop,
  Store,
  StoreMallDirectory,
  StreetView,
  SubdirectoryArrowLeft,
  SubdirectoryArrowRight,
  Subject,
  SubtitlesOff,
  Subway,
  SupervisedUserCircle,
  SupervisorAccount,
  Support,
  SwapCalls,
  SwapHorizontal,
  SwapHorizontalCircle,
  SwapVertical,
  SwapVerticalCircle,
  Swipe,
  SwitchAccount,
  SwitchLeft,
  SwitchRight,
  SyncAlt,
  SystemUpdateAlt,
  Tab,
  TableView,
  TabUnselected,
  TakeOutDining,
  TaxiAlert,
  Terrain,
  TextRotateUp,
  TextRotateVertical,
  TextRotationAngleDown,
  TextRotationAngleUp,
  TextRotationDown,
  TextRotationNone,
  SMSText,
  TextSnippet,
  TheaterComedy,
  Theaters,
  ThumbDown,
  ThumbDownAlt,
  ThumbDownOffAlt,
  ThumbsUpDown,
  ThumbUp,
  ThumbUpAlt,
  ThumbUpOffAlt,
  Timeline,
  Toc,
  Today,
  Toll,
  Topic,
  Torch,
  TouchApp,
  Tour,
  TrackChanges,
  Traffic,
  Train,
  Tram,
  TransferWithinStation,
  TransitEnterExit,
  Translate,
  TrendingDown,
  TrendingFlat,
  TrendingUp,
  TripOrigin,
  TurnedIn,
  TurnedInNot,
  TwoWheeler,
  UnfoldLess,
  UnfoldMore,
  Unpublished,
  Unsubscribe,
  Update,
  UpdateExpense,
  UpdateExpenseSecondary,
  Upgrade,
  UploadFile,
  Verified,
  VerifiedUser,
  VerticalSplit,
  ViewAgenda,
  ViewArray,
  ViewCarousel,
  ViewColumn,
  ViewDay,
  ViewHeadline,
  ViewInAr,
  ViewList,
  ViewModule,
  ViewQuilt,
  ViewSidebar,
  ViewStream,
  ViewWeek,
  Visibility,
  VisibilityOff,
  Voicemail,
  VoiceOverOff,
  VolunteerActivism,
  VpnKey,
  Warning,
  WatchLater,
  WaterfallChart,
  West,
  Whatsapp,
  Whatshot,
  WifiCalling,
  WifiProtectedSetup,
  WineBar,
  Work,
  WorkOff,
  WorkOutline,
  WorkspacesFilled,
  WorkspacesOutline,
  WrongLocation,
  Wysiwyg,
  YoutubeSearchedFor,
  ZoomIn,
  ZoomOut,
  ZoomOutMap,
  Success,
  TickMark,
  NoResultsFoundIcon,
  StarFilled,
  StarEmpty,
} from "@egovernments/digit-ui-svg-components";
import PropTypes from "prop-types";
// Wrapper function that conditionally adds accessibility props for interactive icons
const createSVGWrapper = (Component, ariaLabel) => {
  const WrappedComponent = (props) => {
    const { onClick, ...otherProps } = props;

    // A handler to trigger the onClick event when the 'Enter' key is pressed
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key===" ") {
        onClick(e);
      }
    };

    // If an onClick prop is provided, wrap the component in an accessible, clickable span
    if (onClick && typeof onClick === 'function') {
      return (
        <span
          aria-label={ariaLabel}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="button"
          className="wrapperSpan"
        >
          <Component style={{position: "unset"}} onClick={onClick} {...otherProps}/>
        </span>
      );
    }

    // If no onClick prop, return the component as is
    return <Component {...otherProps} />;
  };
  
  return WrappedComponent;
};


export const SVG = {
  NoResultsFoundIcon: createSVGWrapper(NoResultsFoundIcon, "No results found"),
  Success: createSVGWrapper(Success, "Success"),
  TickMark: createSVGWrapper(TickMark, "Tick Mark"),
  Rotation3D: createSVGWrapper(Rotation3D, "3D Rotation"),
  SixFtApart: createSVGWrapper(SixFtApart, "Six Feet Apart"),
  Rotate360: createSVGWrapper(Rotate360, "Rotate 360"),
  Accessibility: createSVGWrapper(Accessibility, "Accessibility"),
  AccessibilityNew: createSVGWrapper(AccessibilityNew, "Accessibility New"),
  Accessible: createSVGWrapper(Accessible, "Accessible"),
  AccessibleForward: createSVGWrapper(AccessibleForward, "Accessible Forward"),
  AccountBalance: createSVGWrapper(AccountBalance, "Account Balance"),
  AccountBalanceWallet: createSVGWrapper(AccountBalanceWallet, "Account Balance Wallet"),
  AccountBox: createSVGWrapper(AccountBox, "Account Box"),
  AccountCircle: createSVGWrapper(AccountCircle, "Account Circle"),
  AddAlert: createSVGWrapper(AddAlert, "Add Alert"),
  AddBusiness: createSVGWrapper(AddBusiness, "Add Business"),
  AddChart: createSVGWrapper(AddChart, "Add Chart"),
  AddExpense: createSVGWrapper(AddExpense, "Add Expense"),
  AddExpenseTwo: createSVGWrapper(AddExpenseTwo, "Add Expense Two"),
  AddIcCall: createSVGWrapper(AddIcCall, "Add Call"),
  AddLocation: createSVGWrapper(AddLocation, "Add Location"),
  AddLocationAlt: createSVGWrapper(AddLocationAlt, "Add Alternate Location"),
  AddModerator: createSVGWrapper(AddModerator, "Add Moderator"),
  AddRoad: createSVGWrapper(AddRoad, "Add Road"),
  AddShoppingCart: createSVGWrapper(AddShoppingCart, "Add to Shopping Cart"),
  AddTask: createSVGWrapper(AddTask, "Add Task"),
  AddToDrive: createSVGWrapper(AddToDrive, "Add to Drive"),
  AdminPanelSettings: createSVGWrapper(AdminPanelSettings, "Admin Panel Settings"),
  Agriculture: createSVGWrapper(Agriculture, "Agriculture"),
  Alarm: createSVGWrapper(Alarm, "Alarm"),
  AlarmAdd: createSVGWrapper(AlarmAdd, "Add Alarm"),
  AlarmOff: createSVGWrapper(AlarmOff, "Alarm Off"),
  AlarmOn: createSVGWrapper(AlarmOn, "Alarm On"),
  AllInbox: createSVGWrapper(AllInbox, "All Inbox"),
  AllOut: createSVGWrapper(AllOut, "All Out"),
  AlternateEmail: createSVGWrapper(AlternateEmail, "Alternate Email"),
  AltRoute: createSVGWrapper(AltRoute, "Alternate Route"),
  Analytics: createSVGWrapper(Analytics, "Analytics"),
  Anchor: createSVGWrapper(Anchor, "Anchor"),
  Android: createSVGWrapper(Android, "Android"),
  Announcement: createSVGWrapper(Announcement, "Announcement"),
  Api: createSVGWrapper(Api, "API"),
  AppBlocking: createSVGWrapper(AppBlocking, "App Blocking"),
  AppRegistration: createSVGWrapper(AppRegistration, "App Registration"),
  Approval: createSVGWrapper(Approval, "Approval"),
  Apps: createSVGWrapper(Apps, "Apps"),
  AppSettingsAlt: createSVGWrapper(AppSettingsAlt, "App Settings Alternate"),
  Architecture: createSVGWrapper(Architecture, "Architecture"),
  ArrowBack: createSVGWrapper(ArrowBack, "Arrow Back"),
  ArrowBackIos: createSVGWrapper(ArrowBackIos, "Arrow Back IOS"),
  ArrowCircleDown: createSVGWrapper(ArrowCircleDown, "Arrow Circle Down"),
  ArrowCircleUp: createSVGWrapper(ArrowCircleUp, "Arrow Circle Up"),
  ArrowDownward: createSVGWrapper(ArrowDownward, "Arrow Downward"),
  ArrowDropDown: createSVGWrapper(ArrowDropDown, "Arrow Drop Down"),
  ArrowDropDownCircle: createSVGWrapper(ArrowDropDownCircle, "Arrow Drop Down Circle"),
  ArrowDropUp: createSVGWrapper(ArrowDropUp, "Arrow Drop Up"),
  ArrowForward: createSVGWrapper(ArrowForward, "Arrow Forward"),
  ArrowForwardIos: createSVGWrapper(ArrowForwardIos, "Arrow Forward IOS"),
  ArrowForwardIosAlt: createSVGWrapper(ArrowForwardIosAlt, "Arrow Forward IOS Alternate"),
  ArrowLeft: createSVGWrapper(ArrowLeft, "Arrow Left"),
  ArrowRight: createSVGWrapper(ArrowRight, "Arrow Right"),
  ArrowRightAlt: createSVGWrapper(ArrowRightAlt, "Arrow Right Alternate"),
  ArrowUpward: createSVGWrapper(ArrowUpward, "Arrow Upward"),
  Article: createSVGWrapper(Article, "Article"),
  AspectRatio: createSVGWrapper(AspectRatio, "Aspect Ratio"),
  Assessment: createSVGWrapper(Assessment, "Assessment"),
  Assignment: createSVGWrapper(Assignment, "Assignment"),
  AssignmentInd: createSVGWrapper(AssignmentInd, "Assignment Individual"),
  AssignmentLate: createSVGWrapper(AssignmentLate, "Assignment Late"),
  AssignmentReturn: createSVGWrapper(AssignmentReturn, "Assignment Return"),
  AssignmentReturned: createSVGWrapper(AssignmentReturned, "Assignment Returned"),
  AssignmentTurnedIn: createSVGWrapper(AssignmentTurnedIn, "Assignment Turned In"),
  AssistantDirection: createSVGWrapper(AssistantDirection, "Assistant Direction"),
  AssistantNavigation: createSVGWrapper(AssistantNavigation, "Assistant Navigation"),
  Atm: createSVGWrapper(Atm, "ATM"),
  AttachEmail: createSVGWrapper(AttachEmail, "Attach Email"),
  Attachment: createSVGWrapper(Attachment, "Attachment"),
  Attractions: createSVGWrapper(Attractions, "Attractions"),
  AutoDelete: createSVGWrapper(AutoDelete, "Auto Delete"),
  AutoRenew: createSVGWrapper(AutoRenew, "Auto Renew"),
  Backup: createSVGWrapper(Backup, "Backup"),
  BackupTable: createSVGWrapper(BackupTable, "Backup Table"),
  Badge: createSVGWrapper(Badge, "Badge"),
  BakeryDining: createSVGWrapper(BakeryDining, "Bakery Dining"),
  BatchPrediction: createSVGWrapper(BatchPrediction, "Batch Prediction"),
  BeenHere: createSVGWrapper(BeenHere, "Been Here"),
  BikeScooter: createSVGWrapper(BikeScooter, "Bike Scooter"),
  Book: createSVGWrapper(Book, "Book"),
  Bookmark: createSVGWrapper(Bookmark, "Bookmark"),
  BookmarkBorder: createSVGWrapper(BookmarkBorder, "Bookmark Border"),
  Bookmarks: createSVGWrapper(Bookmarks, "Bookmarks"),
  BookOnline: createSVGWrapper(BookOnline, "Book Online"),
  BreakfastDining: createSVGWrapper(BreakfastDining, "Breakfast Dining"),
  BrunchDining: createSVGWrapper(BrunchDining, "Brunch Dining"),
  BugReport: createSVGWrapper(BugReport, "Bug Report"),
  Build: createSVGWrapper(Build, "Build"),
  BuildCircle: createSVGWrapper(BuildCircle, "Build Circle"),
  BusAlert: createSVGWrapper(BusAlert, "Bus Alert"),
  Business: createSVGWrapper(Business, "Business"),
  Cached: createSVGWrapper(Cached, "Cached"),
  Cake: createSVGWrapper(Cake, "Cake"),
  CalendarToday: createSVGWrapper(CalendarToday, "Calendar Today"),
  CalendarViewDay: createSVGWrapper(CalendarViewDay, "Calendar View Day"),
  Call: createSVGWrapper(Call, "Call"),
  CallEnd: createSVGWrapper(CallEnd, "Call End"),
  CallMade: createSVGWrapper(CallMade, "Call Made"),
  CallMerge: createSVGWrapper(CallMerge, "Call Merge"),
  CallMissed: createSVGWrapper(CallMissed, "Call Missed"),
  CallMissedOutgoing: createSVGWrapper(CallMissedOutgoing, "Call Missed Outgoing"),
  CallReceived: createSVGWrapper(CallReceived, "Call Received"),
  CallSplit: createSVGWrapper(CallSplit, "Call Split"),
  CameraEnhance: createSVGWrapper(CameraEnhance, "Camera Enhance"),
  Campaign: createSVGWrapper(Campaign, "Campaign"),
  Cancel: createSVGWrapper(Cancel, "Cancel"),
  CancelPresentation: createSVGWrapper(CancelPresentation, "Cancel Presentation"),
  CancelScheduleSend: createSVGWrapper(CancelScheduleSend, "Cancel Schedule Send"),
  CardGiftcard: createSVGWrapper(CardGiftcard, "Card Giftcard"),
  CardMembership: createSVGWrapper(CardMembership, "Card Membership"),
  CardTravel: createSVGWrapper(CardTravel, "Card Travel"),
  CarRental: createSVGWrapper(CarRental, "Car Rental"),
  CarRepair: createSVGWrapper(CarRepair, "Car Repair"),
  Category: createSVGWrapper(Category, "Category"),
  Celebration: createSVGWrapper(Celebration, "Celebration"),
  CellWifi: createSVGWrapper(CellWifi, "Cell Wifi"),
  ChangeHistory: createSVGWrapper(ChangeHistory, "Change History"),
  Chat: createSVGWrapper(Chat, "Chat"),
  ChatBubble: createSVGWrapper(ChatBubble, "Chat Bubble"),
  ChatBubbleOutline: createSVGWrapper(ChatBubbleOutline, "Chat Bubble Outline"),
  Check: createSVGWrapper(Check, "Check"),
  CheckCircle: createSVGWrapper(CheckCircle, "Check Circle"),
  CheckCircleOutline: createSVGWrapper(CheckCircleOutline, "Check Circle Outline"),
  ChevronLeft: createSVGWrapper(ChevronLeft, "Chevron Left"),
  ChevronRight: createSVGWrapper(ChevronRight, "Chevron Right"),
  ChromeReaderMode: createSVGWrapper(ChromeReaderMode, "Chrome Reader Mode"),
  CircleNotifications: createSVGWrapper(CircleNotifications, "Circle Notifications"),
  Class: createSVGWrapper(Class, "Class"),
  CleanHands: createSVGWrapper(CleanHands, "Clean Hands"),
  CleaningServices: createSVGWrapper(CleaningServices, "Cleaning Services"),
  ClearAll: createSVGWrapper(ClearAll, "Clear All"),
  Clock: createSVGWrapper(Clock, "Clock"),
  Close: createSVGWrapper(Close, "Close"),
  CloseFullscreen: createSVGWrapper(CloseFullscreen, "Close Fullscreen"),
  Cloud: createSVGWrapper(Cloud, "Cloud"),
  CloudCircle: createSVGWrapper(CloudCircle, "Cloud Circle"),
  CloudDone: createSVGWrapper(CloudDone, "Cloud Done"),
  CloudDownload: createSVGWrapper(CloudDownload, "Cloud Download"),
  CloudOff: createSVGWrapper(CloudOff, "Cloud Off"),
  CloudQueue: createSVGWrapper(CloudQueue, "Cloud Queue"),
  CloudUpload: createSVGWrapper(CloudUpload, "Cloud Upload"),
  Code: createSVGWrapper(Code, "Code"),
  Comment: createSVGWrapper(Comment, "Comment"),
  CommentBank: createSVGWrapper(CommentBank, "Comment Bank"),
  Commute: createSVGWrapper(Commute, "Commute"),
  CompareArrows: createSVGWrapper(CompareArrows, "Compare Arrows"),
  CompassCalibration: createSVGWrapper(CompassCalibration, "Compass Calibration"),
  Compress: createSVGWrapper(Compress, "Compress"),
  ConnectWithoutContact: createSVGWrapper(ConnectWithoutContact, "Connect Without Contact"),
  Construction: createSVGWrapper(Construction, "Construction"),
  Contactless: createSVGWrapper(Contactless, "Contactless"),
  ContactMail: createSVGWrapper(ContactMail, "Contact Mail"),
  ContactPage: createSVGWrapper(ContactPage, "Contact Page"),
  ContactPhone: createSVGWrapper(ContactPhone, "Contact Phone"),
  Contacts: createSVGWrapper(Contacts, "Contacts"),
  ContactSupport: createSVGWrapper(ContactSupport, "Contact Support"),
  Copyright: createSVGWrapper(Copyright, "Copyright"),
  Coronavirus: createSVGWrapper(Coronavirus, "Coronavirus"),
  CreateNewFolder: createSVGWrapper(CreateNewFolder, "Create New Folder"),
  CreditCard: createSVGWrapper(CreditCard, "Credit Card"),
  Cut: createSVGWrapper(Cut, "Cut"),
  Dangerous: createSVGWrapper(Dangerous, "Dangerous"),
  Dashboard: createSVGWrapper(Dashboard, "Dashboard"),
  DashboardCustomize: createSVGWrapper(DashboardCustomize, "Dashboard Customize"),
  DateRange: createSVGWrapper(DateRange, "Date Range"),
  Deck: createSVGWrapper(Deck, "Deck"),
  Delete: createSVGWrapper(Delete, "Delete"),
  DeleteForever: createSVGWrapper(DeleteForever, "Delete Forever"),
  DeleteOutline: createSVGWrapper(DeleteOutline, "Delete Outline"),
  DeliveryDining: createSVGWrapper(DeliveryDining, "Delivery Dining"),
  DepartureBoard: createSVGWrapper(DepartureBoard, "Departure Board"),
  Description: createSVGWrapper(Description, "Description"),
  DesignServices: createSVGWrapper(DesignServices, "Design Services"),
  DesktopAccessDisabled: createSVGWrapper(DesktopAccessDisabled, "Desktop Access Disabled"),
  DialerSip: createSVGWrapper(DialerSip, "Dialer Sip"),
  Dialpad: createSVGWrapper(Dialpad, "Dialpad"),
  DinnerDining: createSVGWrapper(DinnerDining, "Dinner Dining"),
  Directions: createSVGWrapper(Directions, "Directions"),
  DirectionsBike: createSVGWrapper(DirectionsBike, "Directions Bike"),
  DirectionsBoat: createSVGWrapper(DirectionsBoat, "Directions Boat"),
  DirectionsBus: createSVGWrapper(DirectionsBus, "Directions Bus"),
  DirectionsCar: createSVGWrapper(DirectionsCar, "Directions Car"),
  DirectionsRailway: createSVGWrapper(DirectionsRailway, "Directions Railway"),
  DirectionsRun: createSVGWrapper(DirectionsRun, "Directions Run"),
  DirectionsSubway: createSVGWrapper(DirectionsSubway, "Directions Subway"),
  DirectionsTransit: createSVGWrapper(DirectionsTransit, "Directions Transit"),
  DirectionsWalk: createSVGWrapper(DirectionsWalk, "Directions Walk"),
  DisabledByDefault: createSVGWrapper(DisabledByDefault, "Disabled By Default"),
  Dns: createSVGWrapper(Dns, "DNS"),
  Domain: createSVGWrapper(Domain, "Domain"),
  DomainDisabled: createSVGWrapper(DomainDisabled, "Domain Disabled"),
  DomainVerification: createSVGWrapper(DomainVerification, "Domain Verification"),
  Done: createSVGWrapper(Done, "Done"),
  DoneAll: createSVGWrapper(DoneAll, "Done All"),
  DoneOutline: createSVGWrapper(DoneOutline, "Done Outline"),
  DonutLarge: createSVGWrapper(DonutLarge, "Donut Large"),
  DonutSmall: createSVGWrapper(DonutSmall, "Donut Small"),
  DoubleArrow: createSVGWrapper(DoubleArrow, "Double Arrow"),
  DragIndicator: createSVGWrapper(DragIndicator, "Drag Indicator"),
  DriveFileMove: createSVGWrapper(DriveFileMove, "Drive File Move"),
  DriveFileMoveOutline: createSVGWrapper(DriveFileMoveOutline, "Drive File Move Outline"),
  DriveFileRenameOutline: createSVGWrapper(DriveFileRenameOutline, "Drive File Rename Outline"),
  DriveFolderUpload: createSVGWrapper(DriveFolderUpload, "Drive Folder Upload"),
  DryCleaning: createSVGWrapper(DryCleaning, "Dry Cleaning"),
  DSOTruck: createSVGWrapper(DSOTruck, "DSO Truck"),
  Duo: createSVGWrapper(Duo, "Duo"),
  DynamicForm: createSVGWrapper(DynamicForm, "Dynamic Form"),
  East: createSVGWrapper(East, "East"),
  Eco: createSVGWrapper(Eco, "Eco"),
  Edit: createSVGWrapper(Edit, "Edit"),
  EditAttributes: createSVGWrapper(EditAttributes, "Edit Attributes"),
  EditLocation: createSVGWrapper(EditLocation, "Edit Location"),
  EditOff: createSVGWrapper(EditOff, "Edit Off"),
  EditRoad: createSVGWrapper(EditRoad, "Edit Road"),
  Eject: createSVGWrapper(Eject, "Eject"),
  Elderly: createSVGWrapper(Elderly, "Elderly"),
  ElectricalServices: createSVGWrapper(ElectricalServices, "Electrical Services"),
  ElectricBike: createSVGWrapper(ElectricBike, "Electric Bike"),
  ElectricCar: createSVGWrapper(ElectricCar, "Electric Car"),
  ElectricMoped: createSVGWrapper(ElectricMoped, "Electric Moped"),
  ElectricRickshaw: createSVGWrapper(ElectricRickshaw, "Electric Rickshaw"),
  ElectricScooter: createSVGWrapper(ElectricScooter, "Electric Scooter"),
  Email: createSVGWrapper(Email, "Email"),
  EmojiEmotions: createSVGWrapper(EmojiEmotions, "Emoji Emotions"),
  EmojiEvents: createSVGWrapper(EmojiEvents, "Emoji Events"),
  EmojiFlags: createSVGWrapper(EmojiFlags, "Emoji Flags"),
  EmojiFoodBeverage: createSVGWrapper(EmojiFoodBeverage, "Emoji Food Beverage"),
  EmojiNature: createSVGWrapper(EmojiNature, "Emoji Nature"),
  EmojiObjects: createSVGWrapper(EmojiObjects, "Emoji Objects"),
  EmojiPeople: createSVGWrapper(EmojiPeople, "Emoji People"),
  EmojiSymbols: createSVGWrapper(EmojiSymbols, "Emoji Symbols"),
  EmojiTransportation: createSVGWrapper(EmojiTransportation, "Emoji Transportation"),
  Engineering: createSVGWrapper(Engineering, "Engineering"),
  Error: createSVGWrapper(Error, "Error"),
  ErrorOutline: createSVGWrapper(ErrorOutline, "Error Outline"),
  EuroSymbol: createSVGWrapper(EuroSymbol, "Euro Symbol"),
  Event: createSVGWrapper(Event, "Event"),
  EventSeat: createSVGWrapper(EventSeat, "Event Seat"),
  EvStation: createSVGWrapper(EvStation, "EV Station"),
  ExitToApp: createSVGWrapper(ExitToApp, "Exit To App"),
  Expand: createSVGWrapper(Expand, "Expand"),
  ExpandLess: createSVGWrapper(ExpandLess, "Expand Less"),
  ExpandMore: createSVGWrapper(ExpandMore, "Expand More"),
  Explore: createSVGWrapper(Explore, "Explore"),
  ExploreOff: createSVGWrapper(ExploreOff, "Explore Off"),
  Extension: createSVGWrapper(Extension, "Extension"),
  Face: createSVGWrapper(Face, "Face"),
  Facebook: createSVGWrapper(Facebook, "Facebook"),
  FactCheck: createSVGWrapper(FactCheck, "Fact Check"),
  Fastfood: createSVGWrapper(Fastfood, "Fastfood"),
  Favorite: createSVGWrapper(Favorite, "Favorite"),
  FavoriteBorder: createSVGWrapper(FavoriteBorder, "Favorite Border"),
  Feedback: createSVGWrapper(Feedback, "Feedback"),
  Festival: createSVGWrapper(Festival, "Festival"),
  File: createSVGWrapper(File, "File"),
  FileDownload: createSVGWrapper(FileDownload, "File Download"),
  FileDownloadDone: createSVGWrapper(FileDownloadDone, "File Download Done"),
  FilePresent: createSVGWrapper(FilePresent, "File Present"),
  FileUpload: createSVGWrapper(FileUpload, "File Upload"),
  FilterAlt: createSVGWrapper(FilterAlt, "Filter Alternate"),
  FilterListAlt: createSVGWrapper(FilterListAlt, "Filter List Alternate"),
  FindInPage: createSVGWrapper(FindInPage, "Find In Page"),
  FindReplace: createSVGWrapper(FindReplace, "Find Replace"),
  Fingerprint: createSVGWrapper(Fingerprint, "Fingerprint"),
  Fireplace: createSVGWrapper(Fireplace, "Fireplace"),
  FirstPageAlt: createSVGWrapper(FirstPageAlt, "First Page Alternate"),
  FirstPage: createSVGWrapper(FirstPage, "First Page"),
  FitScreen: createSVGWrapper(FitScreen, "Fit Screen"),
  Flaky: createSVGWrapper(Flaky, "Flaky"),
  Flight: createSVGWrapper(Flight, "Flight"),
  FlightLand: createSVGWrapper(FlightLand, "Flight Land"),
  FlightTakeoff: createSVGWrapper(FlightTakeoff, "Flight Takeoff"),
  FlipToBack: createSVGWrapper(FlipToBack, "Flip To Back"),
  FlipToFront: createSVGWrapper(FlipToFront, "Flip To Front"),
  Folder: createSVGWrapper(Folder, "Folder"),
  FolderOpen: createSVGWrapper(FolderOpen, "Folder Open"),
  FolderShared: createSVGWrapper(FolderShared, "Folder Shared"),
  FollowTheSigns: createSVGWrapper(FollowTheSigns, "Follow The Signs"),
  Forum: createSVGWrapper(Forum, "Forum"),
  ForwardToInbox: createSVGWrapper(ForwardToInbox, "Forward To Inbox"),
  Fullscreen: createSVGWrapper(Fullscreen, "Fullscreen"),
  FullscreenExit: createSVGWrapper(FullscreenExit, "Fullscreen Exit"),
  Gavel: createSVGWrapper(Gavel, "Gavel"),
  GetApp: createSVGWrapper(GetApp, "Get App"),
  Gif: createSVGWrapper(Gif, "GIF"),
  Grade: createSVGWrapper(Grade, "Grade"),
  Grading: createSVGWrapper(Grading, "Grading"),
  GridView: createSVGWrapper(GridView, "Grid View"),
  Group: createSVGWrapper(Group, "Group"),
  GroupAdd: createSVGWrapper(GroupAdd, "Group Add"),
  Groups: createSVGWrapper(Groups, "Groups"),
  GroupWork: createSVGWrapper(GroupWork, "Group Work"),
  GTranslate: createSVGWrapper(GTranslate, "Google Translate"),
  Hail: createSVGWrapper(Hail, "Hail"),
  Handyman: createSVGWrapper(Handyman, "Handyman"),
  Hardware: createSVGWrapper(Hardware, "Hardware"),
  Help: createSVGWrapper(Help, "Help"),
  HelpCenter: createSVGWrapper(HelpCenter, "Help Center"),
  HelpOutline: createSVGWrapper(HelpOutline, "Help Outline"),
  HighlightAlt: createSVGWrapper(HighlightAlt, "Highlight Alternate"),
  HighlightOff: createSVGWrapper(HighlightOff, "Highlight Off"),
  History: createSVGWrapper(History, "History"),
  HistoryEdu: createSVGWrapper(HistoryEdu, "History Education"),
  HistoryToggleOff: createSVGWrapper(HistoryToggleOff, "History Toggle Off"),
  Home: createSVGWrapper(Home, "Home"),
  HomeFilled: createSVGWrapper(HomeFilled, "Home Filled"),
  HomeRepairService: createSVGWrapper(HomeRepairService, "Home Repair Service"),
  HomeWork: createSVGWrapper(HomeWork, "Home Work"),
  HorizontalSplit: createSVGWrapper(HorizontalSplit, "Horizontal Split"),
  Hotel: createSVGWrapper(Hotel, "Hotel"),
  HourglassBottom: createSVGWrapper(HourglassBottom, "Hourglass Bottom"),
  HourglassDisabled: createSVGWrapper(HourglassDisabled, "Hourglass Disabled"),
  HourglassEmpty: createSVGWrapper(HourglassEmpty, "Hourglass Empty"),
  HourglassFull: createSVGWrapper(HourglassFull, "Hourglass Full"),
  HourglassTop: createSVGWrapper(HourglassTop, "Hourglass Top"),
  Http: createSVGWrapper(Http, "HTTP"),
  Https: createSVGWrapper(Https, "HTTPS"),
  Hvac: createSVGWrapper(Hvac, "HVAC"),
  Icecream: createSVGWrapper(Icecream, "Icecream"),
  IconSwerage: createSVGWrapper(IconSwerage, "Sewerage Icon"),
  IconSwerageAlt: createSVGWrapper(IconSwerageAlt, "Sewerage Icon Alternate"),
  ImportantDevices: createSVGWrapper(ImportantDevices, "Important Devices"),
  ImportContacts: createSVGWrapper(ImportContacts, "Import Contacts"),
  ImportExport: createSVGWrapper(ImportExport, "Import Export"),
  Info: createSVGWrapper(Info, "Info"),
  InfoOutline: createSVGWrapper(InfoOutline, "Info Outline"),
  Input: createSVGWrapper(Input, "Input"),
  IntegrationInstructions: createSVGWrapper(IntegrationInstructions, "Integration Instructions"),
  InvertColors: createSVGWrapper(InvertColors, "Invert Colors"),
  InvertColorsOff: createSVGWrapper(InvertColorsOff, "Invert Colors Off"),
  IosShare: createSVGWrapper(IosShare, "IOS Share"),
  KingBed: createSVGWrapper(KingBed, "King Bed"),
  Label: createSVGWrapper(Label, "Label"),
  LabelImportant: createSVGWrapper(LabelImportant, "Label Important"),
  LabelImportantOutline: createSVGWrapper(LabelImportantOutline, "Label Important Outline"),
  LabelOff: createSVGWrapper(LabelOff, "Label Off"),
  LabelOutline: createSVGWrapper(LabelOutline, "Label Outline"),
  TranslateLanguage: createSVGWrapper(TranslateLanguage, "Translate Language"),
  Language: createSVGWrapper(Language, "Language"),
  LastPageAlt: createSVGWrapper(LastPageAlt, "Last Page Alternate"),
  LastPage: createSVGWrapper(LastPage, "Last Page"),
  Launch: createSVGWrapper(Launch, "Launch"),
  Layers: createSVGWrapper(Layers, "Layers"),
  LayersClear: createSVGWrapper(LayersClear, "Layers Clear"),
  Leaderboard: createSVGWrapper(Leaderboard, "Leaderboard"),
  LegendToggle: createSVGWrapper(LegendToggle, "Legend Toggle"),
  Lightbulb: createSVGWrapper(Lightbulb, "Lightbulb"),
  LightbulbOutline: createSVGWrapper(LightbulbOutline, "Lightbulb Outline"),
  LineStyle: createSVGWrapper(LineStyle, "Line Style"),
  LineWeight: createSVGWrapper(LineWeight, "Line Weight"),
  Liquor: createSVGWrapper(Liquor, "Liquor"),
  List: createSVGWrapper(List, "List"),
  ListAlt: createSVGWrapper(ListAlt, "List Alternate"),
  LiveHelp: createSVGWrapper(LiveHelp, "Live Help"),
  LocalActivity: createSVGWrapper(LocalActivity, "Local Activity"),
  LocalAirport: createSVGWrapper(LocalAirport, "Local Airport"),
  LocalAtm: createSVGWrapper(LocalAtm, "Local ATM"),
  LocalBar: createSVGWrapper(LocalBar, "Local Bar"),
  LocalCafe: createSVGWrapper(LocalCafe, "Local Cafe"),
  LocalCarWash: createSVGWrapper(LocalCarWash, "Local Car Wash"),
  LocalConvenienceStore: createSVGWrapper(LocalConvenienceStore, "Local Convenience Store"),
  LocalDining: createSVGWrapper(LocalDining, "Local Dining"),
  LocalDrink: createSVGWrapper(LocalDrink, "Local Drink"),
  LocalFireDepartment: createSVGWrapper(LocalFireDepartment, "Local Fire Department"),
  LocalFlorist: createSVGWrapper(LocalFlorist, "Local Florist"),
  LocalGasStation: createSVGWrapper(LocalGasStation, "Local Gas Station"),
  LocalGroceryStore: createSVGWrapper(LocalGroceryStore, "Local Grocery Store"),
  LocalHospital: createSVGWrapper(LocalHospital, "Local Hospital"),
  LocalHotel: createSVGWrapper(LocalHotel, "Local Hotel"),
  LocalLaundryService: createSVGWrapper(LocalLaundryService, "Local Laundry Service"),
  LocalLibrary: createSVGWrapper(LocalLibrary, "Local Library"),
  LocalMall: createSVGWrapper(LocalMall, "Local Mall"),
  LocalMovies: createSVGWrapper(LocalMovies, "Local Movies"),
  LocalOffer: createSVGWrapper(LocalOffer, "Local Offer"),
  LocalParking: createSVGWrapper(LocalParking, "Local Parking"),
  LocalPharmacy: createSVGWrapper(LocalPharmacy, "Local Pharmacy"),
  LocalPhone: createSVGWrapper(LocalPhone, "Local Phone"),
  LocalPizza: createSVGWrapper(LocalPizza, "Local Pizza"),
  LocalPlay: createSVGWrapper(LocalPlay, "Local Play"),
  LocalPolice: createSVGWrapper(LocalPolice, "Local Police"),
  LocalPostOffice: createSVGWrapper(LocalPostOffice, "Local Post Office"),
  LocalPrintshop: createSVGWrapper(LocalPrintshop, "Local Printshop"),
  LocalSee: createSVGWrapper(LocalSee, "Local See"),
  LocalShipping: createSVGWrapper(LocalShipping, "Local Shipping"),
  LocalTaxi: createSVGWrapper(LocalTaxi, "Local Taxi"),
  LocationCity: createSVGWrapper(LocationCity, "Location City"),
  LocationOff: createSVGWrapper(LocationOff, "Location Off"),
  LocationOn: createSVGWrapper(LocationOn, "Location On"),
  LocationPin: createSVGWrapper(LocationPin, "Location Pin"),
  Lock: createSVGWrapper(Lock, "Lock"),
  LockClock: createSVGWrapper(LockClock, "Lock Clock"),
  LockOpen: createSVGWrapper(LockOpen, "Lock Open"),
  LockOutline: createSVGWrapper(LockOutline, "Lock Outline"),
  Login: createSVGWrapper(Login, "Login"),
  Logout: createSVGWrapper(Logout, "Logout"),
  Loyalty: createSVGWrapper(Loyalty, "Loyalty"),
  Luggage: createSVGWrapper(Luggage, "Luggage"),
  LunchDining: createSVGWrapper(LunchDining, "Lunch Dining"),
  MailOutline: createSVGWrapper(MailOutline, "Mail Outline"),
  Map: createSVGWrapper(Map, "Map"),
  MapsUgc: createSVGWrapper(MapsUgc, "Maps User Generated Content"),
  MarkAsUnread: createSVGWrapper(MarkAsUnread, "Mark As Unread"),
  MarkChatRead: createSVGWrapper(MarkChatRead, "Mark Chat Read"),
  MarkChatUnread: createSVGWrapper(MarkChatUnread, "Mark Chat Unread"),
  MarkEmailRead: createSVGWrapper(MarkEmailRead, "Mark Email Read"),
  MarkEmailUnread: createSVGWrapper(MarkEmailUnread, "Mark Email Unread"),
  MarkunreadMailbox: createSVGWrapper(MarkunreadMailbox, "Mark Unread Mailbox"),
  Masks: createSVGWrapper(Masks, "Masks"),
  Maximize: createSVGWrapper(Maximize, "Maximize"),
  Mediation: createSVGWrapper(Mediation, "Mediation"),
  MedicalServices: createSVGWrapper(MedicalServices, "Medical Services"),
  Menu: createSVGWrapper(Menu, "Menu"),
  MenuBook: createSVGWrapper(MenuBook, "Menu Book"),
  MenuOpen: createSVGWrapper(MenuOpen, "Menu Open"),
  Message: createSVGWrapper(Message, "Message"),
  MilitaryTech: createSVGWrapper(MilitaryTech, "Military Tech"),
  Minimize: createSVGWrapper(Minimize, "Minimize"),
  MiscellaneousServices: createSVGWrapper(MiscellaneousServices, "Miscellaneous Services"),
  MobileScreenShare: createSVGWrapper(MobileScreenShare, "Mobile Screen Share"),
  ModelTraining: createSVGWrapper(ModelTraining, "Model Training"),
  Money: createSVGWrapper(Money, "Money"),
  Mood: createSVGWrapper(Mood, "Mood"),
  MoodBad: createSVGWrapper(MoodBad, "Mood Bad"),
  Moped: createSVGWrapper(Moped, "Moped"),
  MoreHoriz: createSVGWrapper(MoreHoriz, "More Horizontal"),
  MoreTime: createSVGWrapper(MoreTime, "More Time"),
  MoreVert: createSVGWrapper(MoreVert, "More Vertical"),
  MultipleStop: createSVGWrapper(MultipleStop, "Multiple Stop"),
  Museum: createSVGWrapper(Museum, "Museum"),
  MyLocation: createSVGWrapper(MyLocation, "My Location"),
  Nat: createSVGWrapper(Nat, "Nat"),
  Navigation: createSVGWrapper(Navigation, "Navigation"),
  NearMe: createSVGWrapper(NearMe, "Near Me"),
  NearMeDisabled: createSVGWrapper(NearMeDisabled, "Near Me Disabled"),
  NextPlan: createSVGWrapper(NextPlan, "Next Plan"),
  Nightlife: createSVGWrapper(Nightlife, "Nightlife"),
  NightlightRound: createSVGWrapper(NightlightRound, "Nightlight Round"),
  NightsStay: createSVGWrapper(NightsStay, "Nights Stay"),
  NoLuggage: createSVGWrapper(NoLuggage, "No Luggage"),
  NoMeals: createSVGWrapper(NoMeals, "No Meals"),
  NoMealsOuline: createSVGWrapper(NoMealsOuline, "No Meals Outline"),
  North: createSVGWrapper(North, "North"),
  NorthEast: createSVGWrapper(NorthEast, "North East"),
  NorthWest: createSVGWrapper(NorthWest, "North West"),
  NoSim: createSVGWrapper(NoSim, "No Sim"),
  NotAccessible: createSVGWrapper(NotAccessible, "Not Accessible"),
  NoteAdd: createSVGWrapper(NoteAdd, "Note Add"),
  NotificationImportant: createSVGWrapper(NotificationImportant, "Notification Important"),
  Notifications: createSVGWrapper(Notifications, "Notifications"),
  NotificationsActive: createSVGWrapper(NotificationsActive, "Notifications Active"),
  NotificationsNone: createSVGWrapper(NotificationsNone, "Notifications None"),
  NotificationsOff: createSVGWrapper(NotificationsOff, "Notifications Off"),
  NotificationsPaused: createSVGWrapper(NotificationsPaused, "Notifications Paused"),
  NotListedLocation: createSVGWrapper(NotListedLocation, "Not Listed Location"),
  NoTransfer: createSVGWrapper(NoTransfer, "No Transfer"),
  NotStarted: createSVGWrapper(NotStarted, "Not Started"),
  TorchNoun: createSVGWrapper(TorchNoun, "Torch Noun"),
  OfflineBolt: createSVGWrapper(OfflineBolt, "Offline Bolt"),
  OfflinePin: createSVGWrapper(OfflinePin, "Offline Pin"),
  OfflineShare: createSVGWrapper(OfflineShare, "Offline Share"),
  OnlinePrediction: createSVGWrapper(OnlinePrediction, "Online Prediction"),
  Opacity: createSVGWrapper(Opacity, "Opacity"),
  OpenInBrowser: createSVGWrapper(OpenInBrowser, "Open In Browser"),
  OpenInFull: createSVGWrapper(OpenInFull, "Open In Full"),
  OpenInNew: createSVGWrapper(OpenInNew, "Open In New"),
  OpenWith: createSVGWrapper(OpenWith, "Open With"),
  Outbond: createSVGWrapper(Outbond, "Outbound"),
  Outbox: createSVGWrapper(Outbox, "Outbox"),
  OutdoorGrill: createSVGWrapper(OutdoorGrill, "Outdoor Grill"),
  OutgoingMail: createSVGWrapper(OutgoingMail, "Outgoing Mail"),
  Outlet: createSVGWrapper(Outlet, "Outlet"),
  Pages: createSVGWrapper(Pages, "Pages"),
  Pageview: createSVGWrapper(Pageview, "Pageview"),
  PanTool: createSVGWrapper(PanTool, "Pan Tool"),
  Park: createSVGWrapper(Park, "Park"),
  PartyMode: createSVGWrapper(PartyMode, "Party Mode"),
  PausePresentation: createSVGWrapper(PausePresentation, "Pause Presentation"),
  Payment: createSVGWrapper(Payment, "Payment"),
  Payments: createSVGWrapper(Payments, "Payments"),
  PedalBike: createSVGWrapper(PedalBike, "Pedal Bike"),
  Pending: createSVGWrapper(Pending, "Pending"),
  PendingActions: createSVGWrapper(PendingActions, "Pending Actions"),
  People: createSVGWrapper(People, "People"),
  PeopleAlt: createSVGWrapper(PeopleAlt, "People Alternate"),
  PeopleOutline: createSVGWrapper(PeopleOutline, "People Outline"),
  PermCameraMic: createSVGWrapper(PermCameraMic, "Permission Camera Mic"),
  PermContactCalendar: createSVGWrapper(PermContactCalendar, "Permission Contact Calendar"),
  PermDataSetting: createSVGWrapper(PermDataSetting, "Permission Data Setting"),
  PermDeviceInformation: createSVGWrapper(PermDeviceInformation, "Permission Device Information"),
  PermIdentity: createSVGWrapper(PermIdentity, "Permission Identity"),
  PermMedia: createSVGWrapper(PermMedia, "Permission Media"),
  PermPhoneMsg: createSVGWrapper(PermPhoneMsg, "Permission Phone Message"),
  PermScanWifi: createSVGWrapper(PermScanWifi, "Permission Scan Wifi"),
  Person: createSVGWrapper(Person, "Person"),
  PersonAdd: createSVGWrapper(PersonAdd, "Person Add"),
  PersonAddAlt: createSVGWrapper(PersonAddAlt, "Person Add Alternate"),
  PersonAddSecondary: createSVGWrapper(PersonAddSecondary, "Person Add Secondary"),
  PersonAddDisabled: createSVGWrapper(PersonAddDisabled, "Person Add Disabled"),
  PersonOutline: createSVGWrapper(PersonOutline, "Person Outline"),
  PersonPin: createSVGWrapper(PersonPin, "Person Pin"),
  PersonPinCircle: createSVGWrapper(PersonPinCircle, "Person Pin Circle"),
  PersonRemove: createSVGWrapper(PersonRemove, "Person Remove"),
  PersonRemoveAlt: createSVGWrapper(PersonRemoveAlt, "Person Remove Alternate"),
  PersonSearch: createSVGWrapper(PersonSearch, "Person Search"),
  PestControl: createSVGWrapper(PestControl, "Pest Control"),
  PestControlRodent: createSVGWrapper(PestControlRodent, "Pest Control Rodent"),
  Pets: createSVGWrapper(Pets, "Pets"),
  Phone: createSVGWrapper(Phone, "Phone"),
  PhoneDisabled: createSVGWrapper(PhoneDisabled, "Phone Disabled"),
  PhoneEnabled: createSVGWrapper(PhoneEnabled, "Phone Enabled"),
  PhonelinkErase: createSVGWrapper(PhonelinkErase, "Phonelink Erase"),
  PhonelinkLock: createSVGWrapper(PhonelinkLock, "Phonelink Lock"),
  PhonelinkRing: createSVGWrapper(PhonelinkRing, "Phonelink Ring"),
  PhonelinkSetup: createSVGWrapper(PhonelinkSetup, "Phonelink Setup"),
  PictureInPicture: createSVGWrapper(PictureInPicture, "Picture In Picture"),
  PictureInPictureAlt: createSVGWrapper(PictureInPictureAlt, "Picture In Picture Alternate"),
  PinDrop: createSVGWrapper(PinDrop, "Pin Drop"),
  PivotTableChart: createSVGWrapper(PivotTableChart, "Pivot Table Chart"),
  Place: createSVGWrapper(Place, "Place"),
  Plagiarism: createSVGWrapper(Plagiarism, "Plagiarism"),
  PlayForWork: createSVGWrapper(PlayForWork, "Play For Work"),
  Plumbing: createSVGWrapper(Plumbing, "Plumbing"),
  PlusOne: createSVGWrapper(PlusOne, "Plus One"),
  Poll: createSVGWrapper(Poll, "Poll"),
  Polymer: createSVGWrapper(Polymer, "Polymer"),
  Population: createSVGWrapper(Population, "Population"),
  PortableWifiOff: createSVGWrapper(PortableWifiOff, "Portable Wifi Off"),
  PowerSettingsNew: createSVGWrapper(PowerSettingsNew, "Power Settings New"),
  PregnantWoman: createSVGWrapper(PregnantWoman, "Pregnant Woman"),
  PresentToAll: createSVGWrapper(PresentToAll, "Present To All"),
  Preview: createSVGWrapper(Preview, "Preview"),
  Print: createSVGWrapper(Print, "Print"),
  PrintDisabled: createSVGWrapper(PrintDisabled, "Print Disabled"),
  PrivacyTip: createSVGWrapper(PrivacyTip, "Privacy Tip"),
  Psychology: createSVGWrapper(Psychology, "Psychology"),
  Public: createSVGWrapper(Public, "Public"),
  PublicOff: createSVGWrapper(PublicOff, "Public Off"),
  PublishedWithChanges: createSVGWrapper(PublishedWithChanges, "Published With Changes"),
  QrCode: createSVGWrapper(QrCode, "QR Code"),
  QrCodeScanner: createSVGWrapper(QrCodeScanner, "QR Code Scanner"),
  QueryBuilder: createSVGWrapper(QueryBuilder, "Query Builder"),
  QuestionAnswer: createSVGWrapper(QuestionAnswer, "Question Answer"),
  Quickreply: createSVGWrapper(Quickreply, "Quick Reply"),
  RailwayAlert: createSVGWrapper(RailwayAlert, "Railway Alert"),
  RamenDining: createSVGWrapper(RamenDining, "Ramen Dining"),
  RateReview: createSVGWrapper(RateReview, "Rate Review"),
  ReadMore: createSVGWrapper(ReadMore, "Read More"),
  Receipt: createSVGWrapper(Receipt, "Receipt"),
  Recommend: createSVGWrapper(Recommend, "Recommend"),
  RecordVoiceOver: createSVGWrapper(RecordVoiceOver, "Record Voice Over"),
  Redeem: createSVGWrapper(Redeem, "Redeem"),
  ReduceCapacity: createSVGWrapper(ReduceCapacity, "Reduce Capacity"),
  Refresh: createSVGWrapper(Refresh, "Refresh"),
  RemoveDone: createSVGWrapper(RemoveDone, "Remove Done"),
  RemoveModerator: createSVGWrapper(RemoveModerator, "Remove Moderator"),
  RemoveShoppingCart: createSVGWrapper(RemoveShoppingCart, "Remove Shopping Cart"),
  Reorder: createSVGWrapper(Reorder, "Reorder"),
  ReportProblem: createSVGWrapper(ReportProblem, "Report Problem"),
  RequestPage: createSVGWrapper(RequestPage, "Request Page"),
  RequestQuote: createSVGWrapper(RequestQuote, "Request Quote"),
  Restaurant: createSVGWrapper(Restaurant, "Restaurant"),
  RestaurantMenu: createSVGWrapper(RestaurantMenu, "Restaurant Menu"),
  Restore: createSVGWrapper(Restore, "Restore"),
  RestoreFromTrash: createSVGWrapper(RestoreFromTrash, "Restore From Trash"),
  RestorePage: createSVGWrapper(RestorePage, "Restore Page"),
  RingVolume: createSVGWrapper(RingVolume, "Ring Volume"),
  Room: createSVGWrapper(Room, "Room"),
  RoundedCorner: createSVGWrapper(RoundedCorner, "Rounded Corner"),
  Rowing: createSVGWrapper(Rowing, "Rowing"),
  RssFeed: createSVGWrapper(RssFeed, "RSS Feed"),
  Rtt: createSVGWrapper(Rtt, "RTT"),
  Rule: createSVGWrapper(Rule, "Rule"),
  RuleFolder: createSVGWrapper(RuleFolder, "Rule Folder"),
  RunCircle: createSVGWrapper(RunCircle, "Run Circle"),
  Sanitizer: createSVGWrapper(Sanitizer, "Sanitizer"),
  Satellite: createSVGWrapper(Satellite, "Satellite"),
  SavedSearch: createSVGWrapper(SavedSearch, "Saved Search"),
  Schedule: createSVGWrapper(Schedule, "Schedule"),
  ScheduleSend: createSVGWrapper(ScheduleSend, "Schedule Send"),
  School: createSVGWrapper(School, "School"),
  Science: createSVGWrapper(Science, "Science"),
  ScreenShare: createSVGWrapper(ScreenShare, "Screen Share"),
  Search: createSVGWrapper(Search, "Search"),
  SearchOff: createSVGWrapper(SearchOff, "Search Off"),
  Segment: createSVGWrapper(Segment, "Segment"),
  SelfImprovement: createSVGWrapper(SelfImprovement, "Self Improvement"),
  SendAndArchive: createSVGWrapper(SendAndArchive, "Send And Archive"),
  SentimentDissatisfied: createSVGWrapper(SentimentDissatisfied, "Sentiment Dissatisfied"),
  SentimentNeutral: createSVGWrapper(SentimentNeutral, "Sentiment Neutral"),
  SentimentSatisfied: createSVGWrapper(SentimentSatisfied, "Sentiment Satisfied"),
  SentimentSatisfiedAlt: createSVGWrapper(SentimentSatisfiedAlt, "Sentiment Satisfied Alternate"),
  SentimentVeryDissatisfied: createSVGWrapper(SentimentVeryDissatisfied, "Sentiment Very Dissatisfied"),
  SentimentVerySatisfied: createSVGWrapper(SentimentVerySatisfied, "Sentiment Very Satisfied"),
  SetMeal: createSVGWrapper(SetMeal, "Set Meal"),
  Settings: createSVGWrapper(Settings, "Settings"),
  SettingsApplications: createSVGWrapper(SettingsApplications, "Settings Applications"),
  SettingsBackupRestore: createSVGWrapper(SettingsBackupRestore, "Settings Backup Restore"),
  SettingsBluetooth: createSVGWrapper(SettingsBluetooth, "Settings Bluetooth"),
  SettingsBrightness: createSVGWrapper(SettingsBrightness, "Settings Brightness"),
  SettingsCell: createSVGWrapper(SettingsCell, "Settings Cell"),
  SettingsEthernet: createSVGWrapper(SettingsEthernet, "Settings Ethernet"),
  SettingsInputAntenna: createSVGWrapper(SettingsInputAntenna, "Settings Input Antenna"),
  SettingsInputComponent: createSVGWrapper(SettingsInputComponent, "Settings Input Component"),
  SettingsInputComposite: createSVGWrapper(SettingsInputComposite, "Settings Input Composite"),
  SettingsInputHdmi: createSVGWrapper(SettingsInputHdmi, "Settings Input HDMI"),
  SettingsInputVideo: createSVGWrapper(SettingsInputVideo, "Settings Input Video"),
  SettingsOverscan: createSVGWrapper(SettingsOverscan, "Settings Overscan"),
  SettingsPhone: createSVGWrapper(SettingsPhone, "Settings Phone"),
  SettingsPower: createSVGWrapper(SettingsPower, "Settings Power"),
  SettingsRemote: createSVGWrapper(SettingsRemote, "Settings Remote"),
  SettingsVoice: createSVGWrapper(SettingsVoice, "Settings Voice"),
  Share: createSVGWrapper(Share, "Share"),
  Shop: createSVGWrapper(Shop, "Shop"),
  ShoppingBag: createSVGWrapper(ShoppingBag, "Shopping Bag"),
  ShoppingBasket: createSVGWrapper(ShoppingBasket, "Shopping Basket"),
  ShoppingCart: createSVGWrapper(ShoppingCart, "Shopping Cart"),
  ShopAlt: createSVGWrapper(ShopAlt, "Shop Alternate"),
  Sick: createSVGWrapper(Sick, "Sick"),
  SingleBed: createSVGWrapper(SingleBed, "Single Bed"),
  SmartButton: createSVGWrapper(SmartButton, "Smart Button"),
  SnippetFolder: createSVGWrapper(SnippetFolder, "Snippet Folder"),
  Source: createSVGWrapper(Source, "Source"),
  South: createSVGWrapper(South, "South"),
  SouthEast: createSVGWrapper(SouthEast, "South East"),
  SouthWest: createSVGWrapper(SouthWest, "South West"),
  SpeakerNotes: createSVGWrapper(SpeakerNotes, "Speaker Notes"),
  SpeakerNotesOff: createSVGWrapper(SpeakerNotesOff, "Speaker Notes Off"),
  SpeakerPhone: createSVGWrapper(SpeakerPhone, "Speaker Phone"),
  SpellCheck: createSVGWrapper(SpellCheck, "Spell Check"),
  Sports: createSVGWrapper(Sports, "Sports"),
  SportsBaseball: createSVGWrapper(SportsBaseball, "Sports Baseball"),
  SportsBasketball: createSVGWrapper(SportsBasketball, "Sports Basketball"),
  SportsCricket: createSVGWrapper(SportsCricket, "Sports Cricket"),
  SportsEsports: createSVGWrapper(SportsEsports, "Sports Esports"),
  SportsFootball: createSVGWrapper(SportsFootball, "Sports Football"),
  SportsGolf: createSVGWrapper(SportsGolf, "Sports Golf"),
  SportsHandball: createSVGWrapper(SportsHandball, "Sports Handball"),
  SportsHockey: createSVGWrapper(SportsHockey, "Sports Hockey"),
  SportsKabaddi: createSVGWrapper(SportsKabaddi, "Sports Kabaddi"),
  SportsMma: createSVGWrapper(SportsMma, "Sports MMA"),
  SportsMotorsports: createSVGWrapper(SportsMotorsports, "Sports Motorsports"),
  SportsRugby: createSVGWrapper(SportsRugby, "Sports Rugby"),
  SportsSoccer: createSVGWrapper(SportsSoccer, "Sports Soccer"),
  SportsTennis: createSVGWrapper(SportsTennis, "Sports Tennis"),
  SportsVolleyball: createSVGWrapper(SportsVolleyball, "Sports Volleyball"),
  StarRate: createSVGWrapper(StarRate, "Star Rate"),
  Stars: createSVGWrapper(Stars, "Stars"),
  StayCurrentLandscape: createSVGWrapper(StayCurrentLandscape, "Stay Current Landscape"),
  StayCurrentPortrait: createSVGWrapper(StayCurrentPortrait, "Stay Current Portrait"),
  StayPrimaryLandscape: createSVGWrapper(StayPrimaryLandscape, "Stay Primary Landscape"),
  StayPrimaryPortrait: createSVGWrapper(StayPrimaryPortrait, "Stay Primary Portrait"),
  StickyNotesSecondary: createSVGWrapper(StickyNotesSecondary, "Sticky Notes Secondary"),
  ScreenShareStop: createSVGWrapper(ScreenShareStop, "Stop Screen Share"),
  Store: createSVGWrapper(Store, "Store"),
  StoreMallDirectory: createSVGWrapper(StoreMallDirectory, "Store Mall Directory"),
  StreetView: createSVGWrapper(StreetView, "Street View"),
  SubdirectoryArrowLeft: createSVGWrapper(SubdirectoryArrowLeft, "Subdirectory Arrow Left"),
  SubdirectoryArrowRight: createSVGWrapper(SubdirectoryArrowRight, "Subdirectory Arrow Right"),
  Subject: createSVGWrapper(Subject, "Subject"),
  SubtitlesOff: createSVGWrapper(SubtitlesOff, "Subtitles Off"),
  Subway: createSVGWrapper(Subway, "Subway"),
  SupervisedUserCircle: createSVGWrapper(SupervisedUserCircle, "Supervised User Circle"),
  SupervisorAccount: createSVGWrapper(SupervisorAccount, "Supervisor Account"),
  Support: createSVGWrapper(Support, "Support"),
  SwapCalls: createSVGWrapper(SwapCalls, "Swap Calls"),
  SwapHorizontal: createSVGWrapper(SwapHorizontal, "Swap Horizontal"),
  SwapHorizontalCircle: createSVGWrapper(SwapHorizontalCircle, "Swap Horizontal Circle"),
  SwapVertical: createSVGWrapper(SwapVertical, "Swap Vertical"),
  SwapVerticalCircle: createSVGWrapper(SwapVerticalCircle, "Swap Vertical Circle"),
  Swipe: createSVGWrapper(Swipe, "Swipe"),
  SwitchAccount: createSVGWrapper(SwitchAccount, "Switch Account"),
  SwitchLeft: createSVGWrapper(SwitchLeft, "Switch Left"),
  SwitchRight: createSVGWrapper(SwitchRight, "Switch Right"),
  SyncAlt: createSVGWrapper(SyncAlt, "Sync Alternate"),
  SystemUpdateAlt: createSVGWrapper(SystemUpdateAlt, "System Update Alternate"),
  Tab: createSVGWrapper(Tab, "Tab"),
  TableView: createSVGWrapper(TableView, "Table View"),
  TabUnselected: createSVGWrapper(TabUnselected, "Tab Unselected"),
  TakeOutDining: createSVGWrapper(TakeOutDining, "Takeout Dining"),
  TaxiAlert: createSVGWrapper(TaxiAlert, "Taxi Alert"),
  Terrain: createSVGWrapper(Terrain, "Terrain"),
  TextRotateUp: createSVGWrapper(TextRotateUp, "Text Rotate Up"),
  TextRotateVertical: createSVGWrapper(TextRotateVertical, "Text Rotate Vertical"),
  TextRotationAngleDown: createSVGWrapper(TextRotationAngleDown, "Text Rotation Angle Down"),
  TextRotationAngleUp: createSVGWrapper(TextRotationAngleUp, "Text Rotation Angle Up"),
  TextRotationDown: createSVGWrapper(TextRotationDown, "Text Rotation Down"),
  TextRotationNone: createSVGWrapper(TextRotationNone, "Text Rotation None"),
  SMSText: createSVGWrapper(SMSText, "SMS Text"),
  TextSnippet: createSVGWrapper(TextSnippet, "Text Snippet"),
  TheaterComedy: createSVGWrapper(TheaterComedy, "Theater Comedy"),
  Theaters: createSVGWrapper(Theaters, "Theaters"),
  ThumbDown: createSVGWrapper(ThumbDown, "Thumb Down"),
  ThumbDownAlt: createSVGWrapper(ThumbDownAlt, "Thumb Down Alternate"),
  ThumbDownOffAlt: createSVGWrapper(ThumbDownOffAlt, "Thumb Down Off Alternate"),
  ThumbsUpDown: createSVGWrapper(ThumbsUpDown, "Thumbs Up Down"),
  ThumbUp: createSVGWrapper(ThumbUp, "Thumb Up"),
  ThumbUpAlt: createSVGWrapper(ThumbUpAlt, "Thumb Up Alternate"),
  ThumbUpOffAlt: createSVGWrapper(ThumbUpOffAlt, "Thumb Up Off Alternate"),
  Timeline: createSVGWrapper(Timeline, "Timeline"),
  Toc: createSVGWrapper(Toc, "Table of Contents"),
  Today: createSVGWrapper(Today, "Today"),
  Toll: createSVGWrapper(Toll, "Toll"),
  Topic: createSVGWrapper(Topic, "Topic"),
  Torch: createSVGWrapper(Torch, "Torch"),
  TouchApp: createSVGWrapper(TouchApp, "Touch App"),
  Tour: createSVGWrapper(Tour, "Tour"),
  TrackChanges: createSVGWrapper(TrackChanges, "Track Changes"),
  Traffic: createSVGWrapper(Traffic, "Traffic"),
  Train: createSVGWrapper(Train, "Train"),
  Tram: createSVGWrapper(Tram, "Tram"),
  TransferWithinStation: createSVGWrapper(TransferWithinStation, "Transfer Within Station"),
  TransitEnterExit: createSVGWrapper(TransitEnterExit, "Transit Enter Exit"),
  Translate: createSVGWrapper(Translate, "Translate"),
  TrendingDown: createSVGWrapper(TrendingDown, "Trending Down"),
  TrendingFlat: createSVGWrapper(TrendingFlat, "Trending Flat"),
  TrendingUp: createSVGWrapper(TrendingUp, "Trending Up"),
  TripOrigin: createSVGWrapper(TripOrigin, "Trip Origin"),
  TurnedIn: createSVGWrapper(TurnedIn, "Turned In"),
  TurnedInNot: createSVGWrapper(TurnedInNot, "Turned In Not"),
  TwoWheeler: createSVGWrapper(TwoWheeler, "Two Wheeler"),
  UnfoldLess: createSVGWrapper(UnfoldLess, "Unfold Less"),
  UnfoldMore: createSVGWrapper(UnfoldMore, "Unfold More"),
  Unpublished: createSVGWrapper(Unpublished, "Unpublished"),
  Unsubscribe: createSVGWrapper(Unsubscribe, "Unsubscribe"),
  Update: createSVGWrapper(Update, "Update"),
  UpdateExpense: createSVGWrapper(UpdateExpense, "Update Expense"),
  UpdateExpenseSecondary: createSVGWrapper(UpdateExpenseSecondary, "Update Expense Secondary"),
  Upgrade: createSVGWrapper(Upgrade, "Upgrade"),
  UploadFile: createSVGWrapper(UploadFile, "Upload File"),
  Verified: createSVGWrapper(Verified, "Verified"),
  VerifiedUser: createSVGWrapper(VerifiedUser, "Verified User"),
  VerticalSplit: createSVGWrapper(VerticalSplit, "Vertical Split"),
  ViewAgenda: createSVGWrapper(ViewAgenda, "View Agenda"),
  ViewArray: createSVGWrapper(ViewArray, "View Array"),
  ViewCarousel: createSVGWrapper(ViewCarousel, "View Carousel"),
  ViewColumn: createSVGWrapper(ViewColumn, "View Column"),
  ViewDay: createSVGWrapper(ViewDay, "View Day"),
  ViewHeadline: createSVGWrapper(ViewHeadline, "View Headline"),
  ViewInAr: createSVGWrapper(ViewInAr, "View In AR"),
  ViewList: createSVGWrapper(ViewList, "View List"),
  ViewModule: createSVGWrapper(ViewModule, "View Module"),
  ViewQuilt: createSVGWrapper(ViewQuilt, "View Quilt"),
  ViewSidebar: createSVGWrapper(ViewSidebar, "View Sidebar"),
  ViewStream: createSVGWrapper(ViewStream, "View Stream"),
  ViewWeek: createSVGWrapper(ViewWeek, "View Week"),
  Visibility: createSVGWrapper(Visibility, "Visibility"),
  VisibilityOff: createSVGWrapper(VisibilityOff, "Visibility Off"),
  Voicemail: createSVGWrapper(Voicemail, "Voicemail"),
  VoiceOverOff: createSVGWrapper(VoiceOverOff, "Voice Over Off"),
  VolunteerActivism: createSVGWrapper(VolunteerActivism, "Volunteer Activism"),
  VpnKey: createSVGWrapper(VpnKey, "VPN Key"),
  Warning: createSVGWrapper(Warning, "Warning"),
  WatchLater: createSVGWrapper(WatchLater, "Watch Later"),
  WaterfallChart: createSVGWrapper(WaterfallChart, "Waterfall Chart"),
  West: createSVGWrapper(West, "West"),
  Whatsapp: createSVGWrapper(Whatsapp, "Whatsapp"),
  Whatshot: createSVGWrapper(Whatshot, "Whatshot"),
  WifiCalling: createSVGWrapper(WifiCalling, "Wifi Calling"),
  WifiProtectedSetup: createSVGWrapper(WifiProtectedSetup, "Wifi Protected Setup"),
  WineBar: createSVGWrapper(WineBar, "Wine Bar"),
  Work: createSVGWrapper(Work, "Work"),
  WorkOff: createSVGWrapper(WorkOff, "Work Off"),
  WorkOutline: createSVGWrapper(WorkOutline, "Work Outline"),
  WorkspacesFilled: createSVGWrapper(WorkspacesFilled, "Workspaces Filled"),
  WorkspacesOutline: createSVGWrapper(WorkspacesOutline, "Workspaces Outline"),
  WrongLocation: createSVGWrapper(WrongLocation, "Wrong Location"),
  Wysiwyg: createSVGWrapper(Wysiwyg, "What You See Is What You Get"),
  YoutubeSearchedFor: createSVGWrapper(YoutubeSearchedFor, "Youtube Searched For"),
  ZoomIn: createSVGWrapper(ZoomIn, "Zoom In"),
  ZoomOut: createSVGWrapper(ZoomOut, "Zoom Out"),
  ZoomOutMap: createSVGWrapper(ZoomOutMap, "Zoom Out Map"),
  StarFilled: createSVGWrapper(StarFilled, "Star Filled"),
  StarEmpty: createSVGWrapper(StarEmpty, "Star Empty"),
};

SVG.propTypes = {
  /** custom width of the svg icon */
  width: PropTypes.string,
  /** custom height of the svg icon */
  height: PropTypes.string,
  /** custom colour of the svg icon */
  fill: PropTypes.string,
  /** custom class of the svg icon */
  className: PropTypes.string,
  /** custom style of the svg icon */
  style: PropTypes.object,
  /** Click Event handler when icon is clicked */
  onClick: PropTypes.func,
};
